import dynamic from "next/dynamic";

export const CaseStudies = dynamic(() => import("./component"));
